import { CircleAlert, Send, X } from 'lucide-react';

type ConfirmOverlayProps = {
  isOpen: boolean;
  isSending: boolean;
  receiver: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmOverlay({ isOpen, isSending, receiver, onCancel, onConfirm }: ConfirmOverlayProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="overlay" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <div className="confirm-sheet">
        <span className="permission-icon danger">
          <CircleAlert size={24} aria-hidden="true" />
        </span>
        <div>
          <p className="panel-kicker">Confirm emergency</p>
          <h2 id="confirm-title">Send SOS to {receiver}?</h2>
          <p>This sends an emergency push alert using the strongest behavior your phone and browser allow.</p>
        </div>
        <div className="confirm-actions">
          <button className="secondary-button" type="button" onClick={onCancel} disabled={isSending}>
            <X size={18} aria-hidden="true" />
            Cancel
          </button>
          <button className="danger-button" type="button" onClick={onConfirm} disabled={isSending}>
            <Send size={18} aria-hidden="true" />
            {isSending ? 'Sending...' : 'Send SOS'}
          </button>
        </div>
      </div>
    </div>
  );
}
